const doc = [({"en":({"adminLabelCompanyInvoice":({"createdDate":"Created date", "price":"Price", "uniqueId":"Invoice No."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;